import * as firebase from 'firebase'
import {tidyObj} from "../helpers.js"
import { Store } from 'vuex';
import ExpertData from '../../data/ExpertData.json'

export default {
  state: {
    experts:[],
      },
  mutations: {
    setExpert(state,payload){
      var found=false;
      for(var i in state.experts ){
        if(state.experts[i].id==payload.id){
          found=true
          //state.experts[i]=payload.content
        } 
      }
      if(!found){
        state.experts.push(payload.content)
      }
    }
  },
  actions: {
    loadExpert({ commit,getters },payload){
      let data
        if(ExpertData && ExpertData[payload]){
          commit('loadingText',false)
          data=ExpertData[payload]
          data.id=payload
          console.log("HAS READ",getters.getViewedDocs,payload)
          data.read=getters.getViewedDocs.includes(payload)
          commit('setExpert',{id:payload,content:tidyObj(data)}) 
          return
      }
      if(getters.getExpert(payload)){
        console.log("EXPERT EXISTS",getters.getExpert(payload))
        return
      }
      commit('loadingText',true)
      
      var db = firebase.firestore();
      var docRef = db.collection("Experts").doc(payload)
      docRef.get().then(function(doc) {
        data=doc.data()
        data.id=payload
        data.read=getters.getViewedDocs.includes(payload)
          commit('loadingText',false)
          commit('setExpert',{id:payload,content:tidyObj(data)}) 
      }).catch(function(error) {
          console.log("Error getting expert:", error);
          commit('loadingText',false)
        });
    }
  },
  getters: {
    getExpert: state => id => {
        for(var expert in state.experts){
            if(state.experts[expert].id==id){
                return state.experts[expert]
            }
        }
        return null
    },
    getExperts(state){
      return state.experts
    }
  }
}

